export default __webpack_public_path__ + "static/media/facebook-logo.447953c2.svg";